import { all, call, fork, put, takeLatest, select } from 'redux-saga/effects'
import { ActionTypes } from '../constants/index'
import { request } from 'src/helpers/request'
import { isDevelopment } from 'src/module/helpers'
import deviceService from 'src/services/deviceService';
// import firebaseService from 'src/services/firebase';
import { persistor } from 'src/store/index';
import authChannel from 'src/helpers/authChannel';
import { isWebView } from 'src/services/firebase';
// import { request } from 'modules/helpers';

/**
 * Login
 */
// const urlApi = 'http://localhost:3333/api/';

// export function* auth({ payload }) {
//   try {
//     const response = yield call(request, 'post', `/auth/login`, payload)
//     const {
//       data: { data },
//     } = response
//     /* disini ya */
//     // if (payload?.remember_me) /* jika remember_me di centang maka login akan selamanya */
//     localStorage.setItem('authToken', JSON.stringify(data))
//     // else
//     // bake_cookie('app_login', data?.token, 1);
//     /* jika remember_me tidak di centang maka login akan 1 jam */

//     // mengambil isi user setting ..
//     yield put({
//       type: ActionTypes.SETTING_STATE,
//       // payload: response
//     })
//     /* simpan login cookie */

//     yield put({
//       type: ActionTypes.USER_LOGIN_SUCCESS,
//       payload: data,
//     })

//     yield put({
//       type: ActionTypes.PROFILE_SET_SUCCESS,
//       payload: data,
//     })
//   } catch (err) {
//     /* istanbul ignore next */
//     console.log(err)

//     const message =
//       err.response !== undefined ? err.response.data : { message: 'Terjadi galat pada server' }

//     yield put({
//       type: ActionTypes.USER_AUTH_FAILURE,
//       payload: message,
//     })

//     localStorage.setItem('authToken', '')
//   }
// }



export function* auth({ payload }) {
  try {
    const devices = deviceService.getDeviceInfo()

    const response = yield call(request, 'post', `/auth/login`, {
      ...payload,
      device_uid: devices.device_ui,
      // device_name: devices.userAgent,
      device_type: isWebView ? 'android' : "browser",
      browser: devices.browser,
      os: devices.os
    })
    const {
      data: { data },
    } = response

    if (isDevelopment)
      console.log(data)

    const requires2FA = data?.requires2FA
    const isTwoFAEnabled = data?.twoFA

    if (data?.token) {
      localStorage.setItem('authToken', JSON.stringify(data))
    }

    // console.log(response?.data)
    if (requires2FA) {
      localStorage.setItem("authChallenge", data?.challenge)
    }




    // if (data?.permissions?.management_notifikasi_ont || data?.user_config?.push_notifications === 1) {
    //   yield fork(initializeUserDevice, userData);
    // }

    authChannel.postMessage({
      type: "LOGIN",
    });
    /* bersihkan pula persistor */


    // jangan load setting dulu kalau belum 2FA



    yield put({
      type: ActionTypes.USER_LOGIN_SUCCESS,
      payload: {
        ...data,
        twoFAEnabled: isTwoFAEnabled,
        twoFAVerified: !requires2FA,
        requires2FA,
        deviceInitialized: false, // Akan diupdate oleh device saga
        deviceMessage: 'Device initialization in progress...'
      },
    })

    if (!requires2FA) {
      yield put({ type: ActionTypes.SETTING_STATE })
      yield put({
        type: ActionTypes.PROFILE_SET_SUCCESS,
        payload: {
          full: data
        },
      })
    }



  } catch (err) {
    if (isDevelopment)
      console.log(err)
    const message =
      err.response !== undefined ? err.response.data : { message: 'Terjadi galat pada server' }

    yield call([persistor, persistor.purge]);

    yield put({
      type: ActionTypes.USER_AUTH_FAILURE,
      payload: message,
    })

    localStorage.setItem('authToken', '')

    try {
      yield call([deviceService, deviceService.clearLocalSession]);
    } catch (deviceError) {
      console.warn('[SAGA] Failed to clear device session:', deviceError);
    }
  }
}



function* logoutFbDevice(user) {
  try {
    if (isDevelopment) {
      console.log('[SAGA] Logging out from device...');
    }

    const deviceResult = yield call(
      [deviceService, deviceService.logoutFromDevice],
      user
    );

    if (deviceResult.success) {
      if (isDevelopment) {
        console.log('[SAGA] Device logout successful');
      }
    } else if (isDevelopment) {
      console.warn(
        '[SAGA] Device logout failed:',
        deviceResult.message
      );
    }
  } catch (deviceError) {
    if (isDevelopment) {
      console.error('[SAGA] Device logout error:', deviceError);
    }
  }
}



// export function* logOutTest(actions) { console.log(actions) }
export function* logOut() {
  try {



    const res = yield call(request, 'post', `/auth/logout`)
    const data = res.data !== undefined ? res.data : 'error'




    if (isDevelopment) {
      const user = yield select(
        (state) => state.authentication
      );

      yield call(logoutFbDevice, user);
      console.log('[SAGA] Backend logout successful:', data);
    }


    yield call([persistor, persistor.purge]);


    localStorage.removeItem('authToken');
    localStorage.removeItem('fcmToken');
    localStorage.removeItem('fcm_token_timestamp');
    localStorage.removeItem('app_locked');
    /* digunakan untuk firebase, tapi sks_device_id untuk device user */
    localStorage.removeItem('device_session');
    // localStorage.removeItem('sks_device_uid');

    localStorage.removeItem('notifications');
    localStorage.removeItem('notification_logs');
    localStorage.removeItem('notification_permission_dismissed');


    // console.log(res);


    // delete_cookie('app_login');

    yield put({
      type: ActionTypes.RESET_SETING_STATE,
      payload: data,
    })

    yield put({
      type: ActionTypes.PROFILE_SET_RESET,
      payload: data,
    })

    yield put({
      type: ActionTypes.REQUEST_RUN_RESET,
    })

    try {
      const firebaseService = require('src/services/firebase').default;
      yield call([firebaseService, firebaseService.clearToken]);
    } catch (firebaseError) {
      console.warn('[SAGA] Firebase token clear failed:', firebaseError);
    }

    yield put({
      type: ActionTypes.USER_LOGOUT_SUCCESS,
      payload: data,
    })

    // Simpan('authToken', '');
  } catch (err) {
    console.log
    if (isDevelopment)
      console.error('[SAGA] Logout error:', err);
    localStorage.removeItem('authToken');
    localStorage.removeItem('fcmToken');
    localStorage.removeItem('device_session');

    try {
      yield call([deviceService, deviceService.clearLocalSession]);
    } catch (deviceError) {
      console.warn('[SAGA] Failed to clear local session:', deviceError);
    }

    yield call([persistor, persistor.purge]);

    yield put({
      type: ActionTypes.USER_LOGOUT_FAILURE,
      payload: err.response?.data || { message: 'Logout failed' },
    })

    yield put({
      type: ActionTypes.DEVICE_LOGOUT_FAILURE,
      payload: {
        error: err.message,
        message: 'Logout from device failed'
      }
    });

  }
}

export default function* root() {
  yield all([
    takeLatest(ActionTypes.USER_AUTH, auth),
    takeLatest(ActionTypes.USER_LOGOUT, logOut)])
}
